import Home from './Page/Home';

const Module = {
    Home
};

export default Module;